<div class="animated fadeIn" [ngClass]="[!settings.menuToggleSetting ? 'text-centre' : '', 
  settings.menuToggleSetting && !item ? 'no-margin' : 
  (settings.menuToggleSetting && item ? 'indent-margin' : (!item ? 'no-margin' : ''))]">
  <ng-template [ngIf]="items.length == 0">
    <div class="cursorPointer relative animated fadeIn menu-item"
      [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
      <div class="font17 menu-item-arrow animated rotate" 
        [ngClass]="settings.darkModeSetting ? 'textWhite' : 'textBlack'" style="width: fit-content;">
        <fa-icon [icon]="faCircleNotch"></fa-icon>
      </div>
    </div>
  </ng-template>
  <ng-template [ngIf]="items.length > 0">
    <ng-container *ngFor="let item of items">
      <div class="relative animated fadeIn menu-item cursorPointer" 
        [ngClass]="['padding' + settings.globalPadding, settings.darkModeSetting ? 'bg-dark' : 'bg-white']">
        <fa-icon [icon]="item.expanded ? faChevronDown : faChevronRight" class="transition4 menu-item-arrow"
          [ngStyle]="{'visibility': !item.hasChildern ? 'hidden' : 'visible'}"  (click)="item.expanded = !item.expanded"
          [ngClass]="['font' + settings.textSizeSetting, settings.darkModeSetting ? 'textWhite' : 'textBlack']"></fa-icon>
        <a href="{{item.link}}" pTooltip="{{item.name}}" tooltipPosition="right" [tooltipDisabled]="settings.menuToggleSetting" (click)="getView(item, $event)">
          <ng-template [ngIf]="item.imageIcon != null">
            <img [src]="item.imageIcon" width="23" height="23" />
          </ng-template>
          <span class="animated fadeIn menu-item-text b-radius padding3"
            [ngClass]="['font' + settings.textSizeSetting, settings.darkModeSetting ? 'textWhite menu-item-dark' : 'textBlack menu-item-light']"
            [ngStyle]="{'background': item.selected && item.viewType == 'MasterDetailView' ? (settings.darkModeSetting ? 'var(--dark-second)' : 'var(--light-blue)') : '', 
                      'display': settings.menuToggleSetting ? 'unset' : 'none'}">
            {{item.name}}
          </span>
        </a>
      </div>
      <ng-template [ngIf]="item.expanded && item.hasChildern">
        <app-menu [item]="item" [userId]="userId" [settings]="settings" [pathList]="pathList"></app-menu>
      </ng-template>
    </ng-container>
  </ng-template>
</div>